export default __webpack_public_path__ + "static/media/background-image.c6b151c0.png";